import { CUSTOMER_STATUS_LIVE } from 'api/customerCockpitProfileApi';
import { buildCustomerStatusById } from 'pages/Cockpit/Pipeline/pipelineHelpers';

export function filterLiveCustomers(customers = [], pipelineReport) {
  const statusByCustomerId = buildCustomerStatusById(pipelineReport);
  return customers.filter(
    (customer) => statusByCustomerId[customer.id] === CUSTOMER_STATUS_LIVE
  );
}
